import { useLoggedInUserId} from "../../../../../src/features/auth/logic/rbac";
import WorkflowStageInfoBanner from "../../../stageWorkflow/components/WorkflowStageInfoBanner";
import { useAppSelector } from "../../../../../src/app/store";
import { selectStageConfigByStage } from "../../logic/slice";
import { CaseStageEnum } from "../../../../../src/api/caseStages";
import WorkflowStageBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageBanner";
import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";
import { ParticipantType } from "../../../../../src/api/participants";

const IoAssignedStage: React.FC = () => {
  const loggedInUserId = useLoggedInUserId();

  const investigatorParticipant = useAppSelector((state) =>
    selectParticipantByType(state, ParticipantType.INVESTIGATOR)
  );
  const investigatorId = investigatorParticipant?.participant_id;

  const isInvestigatingOfficer = loggedInUserId === investigatorId;

  const stageConfig = useAppSelector(selectStageConfigByStage(CaseStageEnum.IO_ASSIGNED));

  if (isInvestigatingOfficer) {
    return (
      <WorkflowStageBanner
        title="Submit Investigation Report"
        description="Update your findings under Investigation Workbench, upload the investigation report as per the board approved format, and mark it as completed to forward the case for review by IO Appointing Authority."
        actions={stageConfig?.actions}
      />
    );
  }

  return (
    <WorkflowStageInfoBanner
      title="Case under investigation by investigating officer"
    />
  );
};

export default IoAssignedStage;
